// @ts-nocheck
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import addDays from "@insite/client-framework/Common/Utilities/addDays";
import getLocalizedDateTime from "@insite/client-framework/Common/Utilities/getLocalizedDateTime";
import { HasCartLineContext, withCartLine } from "@insite/client-framework/Components/CartLineContext";
import { Cart } from "@insite/client-framework/Services/CartService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSettingsCollection } from "@insite/client-framework/Store/Context/ContextSelectors";
import translate from "@insite/client-framework/Translate";
import LocalizedDateTime from "@insite/content-library/Components/LocalizedDateTime";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import DataTable, { DataTableProps } from "@insite/mobius/DataTable";
import { DataTableBodyProps } from "@insite/mobius/DataTable/DataTableBody";
import { DataTableCellProps } from "@insite/mobius/DataTable/DataTableCell";
import { DataTableHeadProps } from "@insite/mobius/DataTable/DataTableHead";
import { DataTableHeaderProps } from "@insite/mobius/DataTable/DataTableHeader";
import { DataTableRowProps } from "@insite/mobius/DataTable/DataTableRow";
import {
    Button,
    DataTableBody,
    DataTableCell,
    DataTableHead,
    DataTableHeader,
    DataTableRow,
} from "@insite/mobius/index";
import Link, { LinkPresentationProps } from "@insite/mobius/Link";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import uniqueId from "@insite/mobius/utilities/uniqueId";
import FlexWrapper, { FlexWrapperProps } from "@store/Library/Components/Toolkit/FlexWrapper";
import ArrowiOSDownward from "@store/Library/Components/Toolkit/Icons/ArrowiOSDownward";
import ArrowiOSUpward from "@store/Library/Components/Toolkit/Icons/ArrowiOSUpward";
import EditFill from "@store/Library/Components/Toolkit/Icons/Edit/EditFill";
import PlusCircleFill from "@store/Library/Components/Toolkit/Icons/PlusCircle/PlusCircleFill";
import TrashFill from "@store/Library/Components/Toolkit/Icons/Trash/TrashFill";
import TextField from "@store/MobiusOverrides/TextField/TextField";
import Typography from "@store/MobiusOverrides/Typography/Typography";
import { linkGetActionLinkProps } from "@store/Themes/common/props/link";
import getDaysDifference from "@store/Framework/Common/Utilities/getDaysDifference";
import setIsEditingDate from "@store/Framework/Store/Greif/Pages/Cart/RequestedDates/Handlers/UpdateIsEditingDates";
import ProductFullTruckLoad, { ProductFullTruckLoadStyles } from "@store/Library/Components/ProductFullTruckLoad";
import ProductLeadTime, { ProductLeadTimeStyles } from "@store/Library/Components/ProductLeadTime";
import Status, { StatusProps } from "@store/Library/Components/Status";
import DatePicker, { DatePickerPresentationProps, DatePickerState } from "@store/MobiusOverrides/DatePicker/DatePicker";
import CartLineQuantity from "@store/Overrides/Widgets/Cart/CartLineQuantity";
import { productLineProps } from "@store/Themes/common/props/productLine";
import { tableProps } from "@store/Themes/common/props/table";
import breakpoint from "@toolkit/Framework/Common/Utilities/breakpoint";
import breakpointValues from "@toolkit/Framework/Common/Utilities/breakpointValues";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins";
import React, { useEffect, useState } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

interface OwnProps {
    cart: Cart;
    extendedStyles?: CartLinesDatesStyles;
    deliveryDatesUpdatedHandler?: (deliveryDates: CartLinesDeliveryDate[]) => void;
}

const mapStateToProps = (state: ApplicationState) => ({
    cartSettings: getSettingsCollection(state).cartSettings,
    language: state.context.session.language,
});

const mapDispatchToProps = {
    setIsEditingDate,
};

type Props = OwnProps &
    HasCartLineContext &
    ResolveThunks<typeof mapDispatchToProps> &
    ReturnType<typeof mapStateToProps>;

interface CartLinesDatesStyles {
    wrapper?: InjectableCss;
    accentWrapper?: InjectableCss;
    linkWrapper?: FlexWrapperProps;
    actionsWrapper?: InjectableCss;
    link?: LinkPresentationProps;
    tableWrapper?: InjectableCss;
    dataTable?: DataTableProps;
    tableHead?: DataTableHeadProps;
    tightHeader?: DataTableHeaderProps;
    tableBody?: DataTableBodyProps;
    tableRow?: DataTableRowProps;
    quantityTableHeader?: DataTableHeaderProps;
    quantityTableCell?: DataTableCellProps;
    dateTableHeader?: DataTableHeaderProps;
    dateTableCell?: DataTableCellProps;
    poTableCell?: DataTableCellProps;
    dateWrapper?: FlexWrapperProps;
    actionsTableHeader?: DataTableHeaderProps;
    actionsTableCell?: DataTableCellProps;
    status?: StatusProps;
    datePicker?: DatePickerPresentationProps;
    linkEdit?: LinkPresentationProps;
    buttonSave?: ButtonPresentationProps;
    buttonCancel?: ButtonPresentationProps;
    linkDelete?: LinkPresentationProps;
    linkAdd?: LinkPresentationProps;
    productFullTruckLoadStyles?: ProductFullTruckLoadStyles;
    productLeadTimeStyles?: ProductLeadTimeStyles;
    tableStyledWrapper?: InjectableCss;
}

const cartLinesDatesStyles: CartLinesDatesStyles = {
    wrapper: productLineProps.requestedDatesWrapper,
    accentWrapper: {
        css: css`
            background-color: ${getColor("common.accent")};
            padding: ${pxToRem(16)};
            ${breakpoint("md", "down")} {
                overflow-x: auto;
            }
        `,
    },
    linkWrapper: {
        extendedStyles: {
            wrapper: {
                css: css`
                    width: 100%;
                    ${spacingStyles(pxToRem(10), pxToRem(5))}
                `,
            },
            content: {
                css: css`
                    ${breakpointValues(["center", null, "space-between", null, null], "justify-content")}
                    align-items: center;
                `,
            },
            item: {
                css: css`
                    text-align: right;
                    width: 100%;
                    padding-top: ${pxToRem(16)};

                    &:nth-child(2) {
                        ${breakpointValues(["flex-end", null, null, "unset", null], "justify-content")}
                    }

                    ${breakpoint("md", "up")} {
                        width: auto;
                        padding-top: unset;
                    }
                `,
            },
        },
    },
    actionsWrapper: {
        css: css`
            width: 100%;
            ${spacingStyles(pxToRem(5), pxToRem(5))}

            [class^="ButtonWrapper"] {
                &:nth-child(2) {
                    margin-top: ${pxToRem(10)};
                }
            }

            ${breakpoint("sm", "up")} {
                [class^="ButtonWrapper"] {
                    &:nth-child(2) {
                        margin-left: ${pxToRem(10)};
                        margin-top: unset;
                    }
                }
            }
        `,
    },
    link: linkGetActionLinkProps(ArrowiOSDownward, "right"),
    dataTable: {
        css: css`
            border: 1px solid ${getColor("common.borderDarker")};
            table-layout: fixed;
            width: unset;
            min-width: 100%;

            ${breakpoint("lg")} {
                width: 100%;
            }
        `,
    },
    tableWrapper: {
        css: css`
            ${breakpoint("sm", "down")} {
                position: relative;
                min-width: 100%;
                max-width: 100%;
                overflow-x: auto;
            }
        `,
    },
    tightHeader: tableProps.tightHeader,
    quantityTableHeader: {
        css: css`
            &&&& {
                ${breakpoint("lg", "up")} {
                    width: ${pxToRem(165)};
                }
            }
        `,
    },
    quantityTableCell: {},
    dateTableHeader: {
        css: css`
            &&&& {
                ${breakpoint("lg", "up")} {
                    width: 80%;
                }
            }
        `,
    },
    dateTableCell: {
        css: css`
            [class*="FormFieldStyle"] {
                min-width: ${pxToRem(235)};

                ${breakpoint("md", "down")} {
                    min-width: ${pxToRem(175)};
                    margin-right: ${pxToRem(16)};
                }
            }
        `,
    },
    dateWrapper: {
        extendedStyles: {
            content: {
                css: css`
                    align-items: center;
                    flex-wrap: nowrap;
                `,
            },
        },
    },
    datePicker: {
        errorProps: {
            css: css`
                display: flex;
                align-items: center;
                white-space: break-spaces;
            `,
        },
        calendarIconProps: {
            css: css`
                position: absolute;
                z-index: 999999;
            `,
        },
    },
    poTableCell: {
        css: css`
            display: flex;
            align-items: center;
            justify-content: space-between;
            [class*="FormFieldStyle"] {
                width: 80%;

                ${breakpoint("md", "down")} {
                    min-width: ${pxToRem(175)};
                    margin-right: ${pxToRem(16)};
                }
            }
        `,
    },
    actionsTableHeader: {
        css: css`
            display: none;

            ${breakpoint("md", "up")} {
                display: table-cell;
            }
        `,
    },
    actionsTableCell: {
        css: css`
            text-align: right;
            display: none;

            ${breakpoint("md", "up")} {
                display: table-cell;
            }
        `,
    },
    status: {
        type: "red",
        showIcon: true,
        extendedStyles: {
            wrapper: {
                css: css`
                    display: inline-flex;
                    width: auto;
                `,
            },
        },
    },
    linkEdit: linkGetActionLinkProps(EditFill),
    buttonSave: {
        variant: "primary",
        sizeVariant: "small",
        css: css`
            ${x => x.theme.button.primary.css}
            ${breakpointValues(["100%", "unset"], "width")}
        `,
    },
    buttonCancel: {
        variant: "tertiary",
        sizeVariant: "small",
        css: css`
            ${x => x.theme.button.tertiary.css}
            ${breakpointValues(["100%", "unset"], "width")}
        `,
    },
    linkDelete: linkGetActionLinkProps(TrashFill),
    linkAdd: linkGetActionLinkProps(PlusCircleFill),
    productFullTruckLoadStyles: {
        ftlWrapper: {
            css: css`
                &&&& {
                    margin-bottom: 0;
                    display: flex;
                    flex-direction: row;
                }
            `,
        },
        ftlIcon: {
            iconProps: {
                color: "primary.contrast",
            },
        },
        additionalInfoText: {
            css: css`
                padding-left: ${pxToRem(4)};
                display: flex;
                align-items: center;
            `,
        },
        fullTruckLoadMessage: {
            tooltip: {
                iconProps: {
                    color: "primary.contrast",
                },
            },
        },
    },
    productLeadTimeStyles: {
        wrapper: {
            css: css`
                display: flex;
                align-items: center;
                margin-bottom: -${pxToRem(2)};
            `,
        },
        calendarTooltipProps: {
            iconProps: {
                color: "common.background",
            },
        },
        statusStyles: {
            extendedStyles: {
                wrapper: {
                    css: css`
                        &&&& {
                            background: transparent;
                            padding: 0;
                            & > div {
                                display: flex;
                                flex-direction: row;
                            }
                        }
                    `,
                },
            },
        },
        leadTimeMessage: {
            text: {
                color: "common.background",
            },
            tooltip: {
                iconProps: {
                    color: "common.background",
                },
                cssOverrides: {
                    tooltipWrapper: css`
                        &&&& {
                            padding: 0;
                        }
                    `,
                },
            },
        },
        backgroundTooltip: {
            css: css`
                height: ${pxToRem(22)};
                margin-left: ${pxToRem(4)};
            `,
        },
    },
    tableStyledWrapper: {
        css: css`
            display: flex;
            flex-direction: row;
            align-items: center;
            flex-wrap: wrap;
        `,
    },
};

export interface CartLinesDeliveryDate {
    id: string;
    quantity: number | string;
    requestedDate: Date | undefined;
    customerOrderPO: string;
    notes: string;
    error?: string;
}

const today = new Date();

const CartLinesDates = ({
    cart,
    cartLine,
    cartSettings,
    language,
    deliveryDatesUpdatedHandler = () => {},
    setIsEditingDate,
    extendedStyles,
}: Props) => {
    const [showDatesTable, setShowDatesTable] = useState(true);
    const [deliveryDates, setDeliveryDates] = useState<CartLinesDeliveryDate[]>([]);
    const [savedDeliveryDates, setSavedDeliveryDates] = useState<CartLinesDeliveryDate[]>([]);
    const [isEditingDates, setIsEditingDates] = useState<boolean>(true);

    if (!deliveryDates) {
        return null;
    }

    const assignDefaultValues = () => {
        return JSON.stringify([
            {
                id: uniqueId(),
                quantity: cartLine.qtyOrdered,
                requestedDate: undefined,
                notes: "",
                customerOrderPO: "",
            },
        ] as CartLinesDeliveryDate[]);
    };

    const deliveryDatesJson = cartLine.properties.deliveryDates || assignDefaultValues();

    useEffect(() => {
        const _deliveryDates: CartLinesDeliveryDate[] = JSON.parse(deliveryDatesJson);
        const isMissingDate = _deliveryDates.some((l: CartLinesDeliveryDate) => !l.requestedDate);
        const isMissingPO = _deliveryDates.some((l: CartLinesDeliveryDate) => !l.customerOrderPO);
        const hasPastDate = _deliveryDates.some(
            (l: CartLinesDeliveryDate) => getDaysDifference(new Date(l.requestedDate!), today) < 0,
        );
        setDeliveryDates(_deliveryDates);

        if (hasPastDate && _deliveryDates.length > 0) {
            const _tempDeliveryDates = _deliveryDates.map(d =>
                d.requestedDate && getDaysDifference(new Date(d.requestedDate), today) < 0
                    ? {
                          ...d,
                          error: translate(
                              "{0} is no longer valid. Please define a new date.",
                              getLocalizedDateTime({ dateTime: new Date(d.requestedDate as Date), language }) ||
                                  translate("Date"),
                          ),
                      }
                    : d,
            );
            setDeliveryDates(_tempDeliveryDates);
            return;
        }

        if (!isMissingDate && !isMissingPO) {
            setIsEditingDate({ isEditingDate: false });
            setIsEditingDates(false);
        } else {
            setIsEditingDate({ isEditingDate: true });
            setIsEditingDates(true);
        }
    }, [deliveryDatesJson]);

    const removeErrorIfAny = () => {
        const _datesHasError = deliveryDates.some(d => d.error);

        if (_datesHasError) {
            deliveryDates.map(d => delete d.error);
        }

        setDeliveryDates(deliveryDates);
    };

    const toggleDatesClickHandler = () => {
        setShowDatesTable(!showDatesTable);
    };

    const enableEditModeHandler = () => {
        setIsEditingDates(true);
        setSavedDeliveryDates(deliveryDates);
        setIsEditingDate({ isEditingDate: true });
    };

    const saveModificationsHandler = () => {
        removeErrorIfAny();

        setIsEditingDates(!isEditingDates);
        deliveryDatesUpdatedHandler(deliveryDates);
        setIsEditingDate({ isEditingDate: false });
    };

    const cancelModificationsHandler = () => {
        setIsEditingDates(!isEditingDates);
        setIsEditingDate({ isEditingDate: false });

        if (savedDeliveryDates) {
            setDeliveryDates(savedDeliveryDates);
        }
    };

    const deleteDateHandler = (id: string) => {
        const filteredDates = deliveryDates.filter(x => x.id !== id);
        setDeliveryDates(filteredDates);
    };

    const addDateHandler = () => {
        setDeliveryDates([
            ...deliveryDates,
            {
                id: uniqueId(),
                quantity: 1,
                requestedDate: undefined,
                notes: "",
                customerOrderPO: "",
            },
        ]);
    };

    const deliveryDateChangeHandler = (selectedDay: Date, id: string) => {
        if (!selectedDay) {
            return;
        }

        const dateIsValid = getDaysDifference(new Date(selectedDay), today) >= 0;

        if (dateIsValid) {
            const _tempDeliveryDates = deliveryDates.map(d =>
                d.id === id ? { ...d, requestedDate: selectedDay, error: undefined } : d,
            );
            setDeliveryDates(_tempDeliveryDates);
        }
    };

    const qtyOrderedByDateChangeHandler = (quantity: number, id: string) => {
        const _tempDeliveryDates = deliveryDates.map(d => (d.id === id ? { ...d, quantity } : d));
        setDeliveryDates(_tempDeliveryDates);
    };

    const poChangeHandler = (po: string, id: string) => {
        const _tempDeliveryDates = deliveryDates.map(d => (d.id === id ? { ...d, customerOrderPO: po } : d));
        setDeliveryDates(_tempDeliveryDates);
    };

    const heading = showDatesTable ? "Hide Requested Dates" : "Show Requested Dates";

    const [styles] = React.useState(() => mergeToNew(cartLinesDatesStyles, extendedStyles));
    const link = linkGetActionLinkProps(showDatesTable ? ArrowiOSDownward : ArrowiOSUpward, "right"); // Greif

    return (
        <StyledWrapper {...styles.wrapper}>
            <Link
                {...link}
                aria-expanded={showDatesTable}
                onClick={toggleDatesClickHandler}
                data-test-selector="cartline_datessShowHideButton"
            >
                {translate(heading)}
            </Link>
            {showDatesTable && (
                <StyledWrapper {...styles.accentWrapper}>
                    {!isEditingDates && (
                        <Link
                            {...styles.linkEdit}
                            onClick={enableEditModeHandler}
                            title={translate("Manage dates and quantities")}
                        >
                            {translate("Edit")}
                        </Link>
                    )}
                    <StyledWrapper {...styles.tableWrapper}>
                        <DataTable {...styles.dataTable}>
                            <DataTableHead {...styles.tableHead}>
                                <DataTableHeader {...styles.quantityTableHeader}>
                                    <StyledWrapper {...styles.tableStyledWrapper}>
                                        {translate("Qty")}
                                        {cartLine.pricing?.additionalResults?.fullTruckLoad && (
                                            <ProductFullTruckLoad
                                                overrideFtl={{
                                                    ftlQuantity: cartLine.pricing?.additionalResults?.fullTruckLoad,
                                                    plant: cartLine.pricing?.additionalResults?.warehouseName,
                                                }}
                                                displayTexts={false}
                                                displayIcons
                                                displaySeparator
                                                overridedStyles={styles.productFullTruckLoadStyles}
                                            />
                                        )}
                                    </StyledWrapper>
                                </DataTableHeader>
                                <DataTableHeader {...styles.dateTableHeader}>
                                    <StyledWrapper {...styles.tableStyledWrapper}>
                                        {translate("Requested Delivery Date")}
                                        {cartLine.pricing?.additionalResults?.leadTime && (
                                            <ProductLeadTime
                                                overridedStyles={styles.productLeadTimeStyles}
                                                overrideLT={{
                                                    isSpecialItem:
                                                        cartLine.pricing?.additionalResults?.isSpecialItem === "True",
                                                    plant: cartLine.pricing?.additionalResults?.warehouseName,
                                                    leadTimeDays: Number(cartLine.pricing?.additionalResults?.leadTime),
                                                    minimumOrderQuantity: Number(
                                                        cartLine.pricing?.additionalResults?.minimumOrderQuantity,
                                                    ),
                                                }}
                                                displayLabel={false}
                                                showShortLeadTimeDesc
                                                displaySeparator
                                            />
                                        )}
                                    </StyledWrapper>
                                </DataTableHeader>
                                <DataTableHeader {...styles.dateTableHeader}>{translate("PO #")}</DataTableHeader>
                                <DataTableHeader {...styles.actionsTableHeader}>{}</DataTableHeader>
                            </DataTableHead>
                            <DataTableBody {...styles.tableBody}>
                                {deliveryDates.map((date, index) => (
                                    <DataTableRow key={index} {...styles.tableRow}>
                                        <DataTableCell {...styles.quantityTableCell}>
                                            <CartLineQuantity
                                                cart={cart}
                                                editable={isEditingDates}
                                                noLabel
                                                overridedQty={Number(date.quantity)}
                                                onQtyOrderedChange={quantity =>
                                                    qtyOrderedByDateChangeHandler(quantity, date.id)
                                                }
                                            />
                                        </DataTableCell>
                                        <DataTableCell {...styles.dateTableCell}>
                                            {isEditingDates ? (
                                                <FlexWrapper {...styles.dateWrapper}>
                                                    <DatePicker
                                                        {...styles.datePicker}
                                                        selectedDay={
                                                            typeof date.requestedDate === "string"
                                                                ? new Date(date.requestedDate)
                                                                : date.requestedDate
                                                        }
                                                        dateTimePickerProps={{
                                                            minDate: today,
                                                            maxDate: addDays(
                                                                new Date(),
                                                                cartSettings.maximumDeliveryPeriod,
                                                            ),
                                                        }}
                                                        onDayChange={({
                                                            selectedDay,
                                                        }: Pick<DatePickerState, "selectedDay">) =>
                                                            deliveryDateChangeHandler(selectedDay!, date.id)
                                                        }
                                                        error={date.error}
                                                    />
                                                </FlexWrapper>
                                            ) : date.requestedDate ? (
                                                <LocalizedDateTime dateTime={date.requestedDate} />
                                            ) : (
                                                <Status {...styles.status}>{translate("Please define date")}</Status>
                                            )}
                                        </DataTableCell>
                                        <DataTableCell {...styles.poTableCell}>
                                            {isEditingDates ? (
                                                <>
                                                    <TextField
                                                        type="text"
                                                        value={date.customerOrderPO}
                                                        onChange={e => poChangeHandler(e.target.value, date.id)}
                                                    />

                                                    {deliveryDates.length > 1 && (
                                                        <Link
                                                            {...styles.linkDelete}
                                                            onClick={() => deleteDateHandler(date.id)}
                                                            title={translate("Delete requested date row.")}
                                                        />
                                                    )}
                                                </>
                                            ) : date.customerOrderPO ? (
                                                <Typography>{date.customerOrderPO}</Typography>
                                            ) : (
                                                <Status {...styles.status}>{translate("Please fill PO#")}</Status>
                                            )}
                                        </DataTableCell>
                                    </DataTableRow>
                                ))}
                            </DataTableBody>
                        </DataTable>
                    </StyledWrapper>
                    {isEditingDates && (
                        <FlexWrapper {...styles.linkWrapper}>
                            <Link {...styles.linkAdd} onClick={addDateHandler}>
                                {translate("Add a requested date")}
                            </Link>
                            {showDatesTable && (
                                <>
                                    {isEditingDates && (
                                        <StyledWrapper {...styles.actionsWrapper}>
                                            <Button
                                                {...styles.buttonCancel}
                                                onClick={cancelModificationsHandler}
                                                title={translate("Cancel changes")}
                                                disabled={!savedDeliveryDates.length}
                                            >
                                                {translate("Cancel")}
                                            </Button>
                                            <Button
                                                {...styles.buttonSave}
                                                onClick={saveModificationsHandler}
                                                title={translate("Apply changes")}
                                            >
                                                {translate("Save")}
                                            </Button>
                                        </StyledWrapper>
                                    )}
                                </>
                            )}
                        </FlexWrapper>
                    )}
                </StyledWrapper>
            )}
        </StyledWrapper>
    );
};

export default withCartLine(connect(mapStateToProps, mapDispatchToProps)(CartLinesDates));
